import { faAngleUp, faBars } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import classNames from "classnames";
import { Link } from 'gatsby';
import iconComachi from "images/logo.png";
import React, { useState } from 'react';
import Style from "styles/components/header.module.scss";

const Header = () => {
  const [showSmileBanner] = useState(false);
  const bannerClass = classNames({
    [Style.header__nav__top__comachiLink__img]: true,
    [Style.header__nav__top__comachiLink__img__disable]: showSmileBanner,
  });
  
  const [isNavOpne, setIsNavOpen] = useState(false);
  const navIconWidth = 13;
  const navIconHeight = 15;
  return (
    <div className={classNames(Style.header)} style={{ backgroundColor: '#fff' }}>
      <div className={classNames(Style.container)}>
        <div className={classNames(Style.header__nav)}>
          <div className={classNames(Style.header__nav__top)}>
            <div className={classNames(Style.header__nav__top__img)}>
              <Link to="/">
                <img className={Style.header__nav__top__logo} src={iconComachi} alt="Comachi ロゴ"/>
              </Link>
            </div>
            <div className={classNames({ [Style.header__nav__top__menu]: true, [Style.header__nav__top__menu__active]: isNavOpne })}>
              <ul>
                <li>
                  <Link to="/func/">機能</Link>
                </li>
                <li>
                  <Link to="/design/">デザイン</Link>
                </li>
                <li>
                  <Link to="/price/">料金</Link>
                </li>
                <li>
                  <Link to="/case_study/">事例</Link>
                </li>
                <li>
                  <Link to="/faq/">よくある質問</Link>
                </li>
                <li>
                  <Link to="/know_how/">BLOG</Link>
                </li>
                <li>
                  <Link to="/news/">お知らせ</Link>
                </li>
              </ul>
            </div>
            <div className={classNames(Style.header__nav__top__bars)} onClick={() => setIsNavOpen(!isNavOpne)}>
              {isNavOpne ? (
                <FontAwesomeIcon className="fa-fw" icon={faAngleUp} width={navIconWidth} height={navIconHeight} />
              ) : (
                <FontAwesomeIcon className="fa-fw" icon={faBars} width={navIconWidth} height={navIconHeight} />
              )}
            </div>
            <div className={Style.header__nav__top__btns}>
              <a
                className={classNames(Style.header__nav__top__btn, Style.header__nav__top__login)}
                href="https://store.comachicart.com/login"
              >
                ログイン
              </a>
              <Link className={classNames(Style.header__nav__top__btn, Style.header__nav__top__application, bannerClass)} to="/application">
                無料でお試し
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Header;
